'use client';

import { useMemo } from 'react';
import { IconSocialResponsibility } from '@/features/icons';
import { cn } from '@/utils/cn';
import { getCdnUrl } from '@/utils/url';
import SectionHeading from './section-heading';
import { useLanguage } from '../context/language-context-provider';
const KhanoumiSocialResponsibility = () => {
  const {
    t,
    language
  } = useLanguage();
  const isEn = language === 'en';
  const ITEMS = useMemo(() => [{
    image: getCdnUrl('/_toad/images/about-us/sr-1.png'),
    title: t('responsibility.item1')
  }, {
    image: getCdnUrl('/_toad/images/about-us/sr-2.png'),
    title: t('responsibility.item2')
  }, {
    image: getCdnUrl('/_toad/images/about-us/sr-3.png'),
    title: t('responsibility.item3')
  }, {
    image: getCdnUrl('/_toad/images/about-us/sr-4.png'),
    title: t('responsibility.item4')
  }, {
    image: getCdnUrl('/_toad/images/about-us/sr-5.png'),
    title: t('responsibility.item5')
  }, {
    image: getCdnUrl('/_toad/images/about-us/sr-6.png'),
    title: t('responsibility.item6')
  }, {
    image: getCdnUrl('/_toad/images/about-us/sr-7.png'),
    title: t('responsibility.item7')
  }, {
    image: getCdnUrl('/_toad/images/about-us/sr-8.png'),
    title: t('responsibility.item8')
  }], [t]);
  return <div className='homepage-container lg:pt-39' data-sentry-component="KhanoumiSocialResponsibility" data-sentry-source-file="khanoumi-social-responsibility.tsx">
            <div className={cn('relative flex flex-col items-center gap-5', isEn ? '!pr-0' : '!pl-0')}>
                <SectionHeading icon={<IconSocialResponsibility />} title={t('responsibility.title')} className='lg:absolute lg:left-22 lg:top-0 lg:-translate-y-1/2' data-sentry-element="SectionHeading" data-sentry-source-file="khanoumi-social-responsibility.tsx">
                    <span className='absolute bottom-1/2 left-1/2 -z-10 hidden h-39 w-px bg-border-pink lg:inline-block' />
                </SectionHeading>

                <p className='text-caption-12 lg:hidden'>{t('responsibility.description')}</p>
                <div className='hide-scrollbar flex w-full gap-3 overflow-x-scroll lg:grid lg:grid-cols-2 lg:gap-y-8 lg:overflow-x-auto lg:rounded-xl lg:border lg:border-solid lg:border-border-pink lg:px-8 lg:py-14'>
                    {ITEMS.map(({
          image,
          title
        }, index) => <div key={index} className='flex flex-col items-center gap-2 rounded-md border border-solid border-border-gray-light bg-surface-solid-50 p-3 lg:flex-row lg:gap-0 lg:border-0 lg:bg-transparent'>
                            <img width={180} height={135} alt={title} src={image} className='h-[135px] min-h-[135px] w-[180px] min-w-[180px] max-w-max object-cover lg:w-[221px] lg:min-w-[221px] lg:rounded lg:border lg:border-solid lg:border-primary-main' />
                            <span className='text-center text-caption-12 font-medium lg:w-full lg:rounded-e-md lg:bg-surface-solid-100 lg:py-8 lg:text-body-16'>
                                {title}
                            </span>
                        </div>)}
                </div>
            </div>
        </div>;
};
export default KhanoumiSocialResponsibility;